<template>
  <v-dialog
    v-if="selected"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="closeDialog(true)"
    @keydown.esc="closeDialog(true)"
    persistent
    max-width="700px"
    :fullscreen="is_mobile"
    :scrollable="true"
    overlay-opacity="50"
    overlay-color="#ffffff"
    content-class="default-dialog"
  >
    <v-card class="default-dialog-card">
      <v-card-title class="dialog-title">
        <span class="headline">
          <v-icon class="toolbar-icon">{{ (id > 0 ? 'mdi-account-edit' : 'mdi-account-plus') }}</v-icon>
          {{ (id > 0 ? `${lang.customers.edit.title} #${id}` : lang.customers.new.title) }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="closeDialog(true)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="py-1 px-2">
        <v-container class="px-1">
          <v-row class="pa-0">
            <v-col cols="12" class="customer-form">
              <v-form
                ref="SaveForm"
                v-model="valid"
                lazy-validation
              >
                <v-row class="customer-form-row">
                  <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                    <v-text-field
                      :label="lang.customers.datatable.headers.name"
                      v-model="selected.name"
                      :rules="lang.customers.edit.rules.nameRules"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      autocomplete="new-password"
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="customer-form-row">
                  <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                    <v-text-field
                      :label="lang.customers.datatable.headers.phone"
                      v-model="selected.phone"
                      :rules="lang.customers.edit.rules.phoneRules"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      v-mask="phone_mask"
                      autocomplete="new-password"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                    <v-text-field
                      :label="lang.customers.datatable.headers.identity"
                      v-model="selected.identity"
                      :rules="lang.customers.edit.rules.cpfRules"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      v-mask="cpf_mask"
                      autocomplete="new-password"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                    <v-menu
                      v-model="date_menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="190px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-bind="attrs"
                          v-on="on"
                          :value="formatDateAlt(selected.birth_date, false)"
                          :label="lang.customers.datatable.headers.birth_date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          filled
                          clearable
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="selected.birth_date"
                        locale="pt-br"
                        no-title
                        @input="date_menu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="addresses-widget">
                    <v-subheader>{{ lang.customers.datatable.headers.addresses }}</v-subheader>
                    <Addresses :addresses="selected.addresses" />
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" text @click="closeDialog(true)">{{ lang.customers.view.close }}</v-btn>
        <v-btn color="red darken-1" v-if="id > 0" text @click="deleteCustomer(selected)">{{ lang.customers.actions.delete }}</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="saveCustomer(selected)"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
        >
          {{ lang.customers.actions.save }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import save from '@/mixins/defaults/save'
import customers from './mixins/index'

import Addresses from './templates/Addresses'

export default {
  mixins: [ appdata, utils, save, customers ],
  components: { Addresses },
  data: () => ({
    valid: false,
    date_menu: false
  })
}
</script>

<style src="./styles/save.scss" lang="scss"></style>
